/**
 * useServiceWorkerUpdate — expõe o estado de "atualização disponível" do SW para
 * a UI (Story X1.1.2).
 *
 * Assina o pub/sub de sw-registration: quando um deploy novo deixa um SW em
 * espera, `updateReady` vira true e o `UpdatePrompt` aparece. `applyUpdate`
 * confirma a troca (SKIP_WAITING + reload).
 */
import { useCallback, useEffect, useState } from "react";

import { applyUpdate, isUpdateReady, subscribeToUpdate } from "@/lib/sw-registration";

export interface UseServiceWorkerUpdateState {
  /** Há uma versão nova do app instalada e aguardando ativação. */
  updateReady: boolean;
  /** Confirma a atualização: ativa o SW novo e recarrega a página. */
  applyUpdate: () => void;
}

export function useServiceWorkerUpdate(): UseServiceWorkerUpdateState {
  const [updateReady, setUpdateReady] = useState<boolean>(() => isUpdateReady());

  useEffect(() => {
    // subscribeToUpdate emite o valor atual imediatamente, então cobre o caso de
    // o evento `waiting` ter disparado antes deste componente montar.
    return subscribeToUpdate(setUpdateReady);
  }, []);

  const handleApply = useCallback(() => {
    applyUpdate();
  }, []);

  return { updateReady, applyUpdate: handleApply };
}

export default useServiceWorkerUpdate;
